import React from 'react';
import Header from './Header';
import Footer from './Footer';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Termini e Condizioni d'Uso</h1>

          <div className="prose prose-gray max-w-none">
            {/* Header intro */}
            <div className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                CONDIZIONI GENERALI D'USO DEL SITO ILTUOAMARO.IT
              </h2>
              <p className="text-gray-700 mb-6">
                Per procedere con l'utilizzo e la navigazione su iltuoamaro.it, è necessario avere un'età superiore ai 18 anni,
                o superiore al limite previsto nel Paese di residenza dell'utente.
              </p>
            </div>

            {/* Titolare del sito */}
            <div className="border-t border-gray-200 pt-8 mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                TITOLARE DEL SITO WEB ILTUOAMARO.IT
              </h3>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="font-semibold text-gray-900">Lacinio S.R.L.</p>
                <p className="text-gray-700">Via G. Mercalli, 16 – Z.I.</p>
                <p className="text-gray-700">88900 Crotone (KR) – ITALIA</p>
                <p className="text-gray-700">P.IVA: 03714460791 – REA KR-184420</p>
                <p className="text-gray-700">Telefono: +39 0962 937186</p>
                <p className="text-gray-700">Email: info@iltuoamaro.it</p>
              </div>
              <p className="text-gray-700 mt-4">
                L'accesso al sito e il suo utilizzo, così come l'acquisto dei prodotti in esso presentati, presuppongono la lettura,
                la conoscenza e l'accettazione delle presenti Condizioni Generali d'Uso.
              </p>
            </div>

            {/* Sezioni numerate */}
            <div className="space-y-8">

              {/* 1 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">1 – Definizioni e disposizioni generali</h3>
                <div className="space-y-3 text-gray-700">
                  <p><strong>1.1.</strong> Ai fini delle presenti condizioni, per <em>Utente</em> si intende il soggetto che utilizza i servizi offerti dal sito www.iltuoamaro.it, sia che si limiti alla consultazione delle informazioni, sia che proceda all'utilizzo delle aree riservate o di qualsiasi funzionalità del sito.</p>
                  <p><strong>1.2.</strong> La fruizione del sito è regolata dalle presenti condizioni di utilizzo. L'accettazione di tali condizioni costituisce un accordo tra l'Utente e il Titolare ed è implicita nel semplice atto di navigazione nel sito.</p>
                  <p><strong>1.3.</strong> Il Titolare potrà predisporre ulteriori regole e condizioni specifiche per singoli servizi offerti nel sito: l'Utente dovrà rispettarle per poter usufruire dei relativi beni e servizi.</p>
                  <p><strong>1.4.</strong> La legge applicabile ai rapporti derivanti dall'utilizzo del sito è quella italiana.</p>
                  <p><strong>1.5.</strong> Con <em>Titolare del servizio</em> si intende in modo univoco Lacinio S.R.L., come indicato in testa al presente documento.</p>
                  <p><strong>1.6.</strong> Il Titolare si riserva di modificare, in qualsiasi momento, anche in modo sostanziale, le presenti condizioni, rendendole note all'Utente tramite pubblicazione sul sito. L'accesso successivo alla modifica comporta l'accettazione delle nuove condizioni.</p>
                  <p><strong>1.7.</strong> I termini tecnici di natura informatica presenti nel testo sono da intendersi nel loro significato comunemente riconosciuto.</p>
                  <p><strong>1.8.</strong> Con il termine <em>applicazione</em> si intende il sito web www.iltuoamaro.it, indipendentemente dal dispositivo utilizzato per accedervi.</p>
                  <p><strong>1.9.</strong> Con <em>Condizioni</em> si intende il presente contratto che disciplina i rapporti tra il Titolare e gli Utenti, fatte salve le previsioni della Privacy Policy.</p>
                </div>
              </section>

              {/* 2 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">2 – Trattamento dei dati</h3>
                <p className="text-gray-700">
                  Il trattamento dei dati personali avviene nel rispetto della normativa europea vigente (Reg. UE 679/2016 – GDPR).
                  Per maggiori informazioni è possibile consultare la nostra Privacy Policy.
                </p>
              </section>

              {/* 3 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">3 – Servizi fruibili direttamente dal sito</h3>
                <div className="space-y-4 text-gray-700">
                  <div>
                    <h4 className="font-semibold mb-2">3.1 Creazione della ricetta per un amaro personalizzato</h4>
                    <p>
                      Il sito consente di creare una ricetta personalizzata per ottenere un amaro dal gusto unico.
                      Il Titolare non è responsabile del risultato finale della ricetta scelta dall'utente, pur garantendo la qualità e l'equilibrio del prodotto.
                    </p>
                    <p className="mt-3"><strong>Proprietà delle ricette.</strong> Tutte le ricette sviluppate, messe a disposizione o create su misura da Lacinio S.R.L. — sia quelle già in catalogo sia quelle formulate su specifica richiesta — sono e rimangono di proprietà intellettuale esclusiva di Lacinio S.R.L. L'utente non acquisisce alcun diritto esclusivo, economico o di utilizzo sulla ricetta elaborata, indipendentemente dalla durata o dal volume del rapporto commerciale.</p>
                    <p className="mt-3"><strong>Acquisto di una ricetta.</strong> L'acquisto della titolarità di una ricetta è possibile esclusivamente previo contatto diretto con l'azienda all'indirizzo e-mail <a href="mailto:info@iltuoamaro.it" className="text-purple-600 underline">info@iltuoamaro.it</a> o <a href="mailto:preventivi@iltuoamaro.it" className="text-purple-600 underline">preventivi@iltuoamaro.it</a>, al fine di richiedere una quotazione personalizzata. Lacinio S.R.L. si riserva di valutare ogni richiesta individualmente e di formulare un'offerta dedicata.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold mb-2">3.1.1 – Riproduzione di ricette esistenti</h4>
                    <p>
                      Nel caso in cui il Cliente richieda la riproduzione o la replicazione di una ricetta già sviluppata da Lacinio S.R.L.,
                      è previsto un costo fisso di <strong>€ 500,00 + IVA</strong>, comprensivo di tre (3) campionature del prodotto destinate alla verifica e all'approvazione da parte del Cliente.
                    </p>
                    <p className="mt-3">
                      In caso di mancata accettazione delle campionature, l'importo di € 500,00 + IVA non sarà rimborsato, in quanto a copertura integrale dei costi di sviluppo, formulazione e produzione dei campioni sostenuti da Lacinio S.R.L. Tale costo è da intendersi come corrispettivo per l'attività di riproduzione della ricetta, indipendentemente dall'esito delle campionature.
                    </p>
                  </div>

                  <div>
                    <h4 className="font-semibold mb-2">3.2 Creazione dell'etichetta personalizzata</h4>
                    <p>
                      Il sito offre la possibilità di personalizzare l'etichetta della bottiglia. Lacinio S.R.L. non è responsabile dei contenuti grafici o testuali creati dall'utente.
                      Si raccomanda di consultare i paragrafi relativi a copyright, regole comportamentali e proprietà intellettuale.
                    </p>
                    <p className="mt-3"><strong>Proprietà della grafica realizzata da Lacinio S.R.L.</strong> Tutta la grafica progettata e realizzata da Lacinio S.R.L. per le etichette e il packaging delle bottiglie del Cliente è di proprietà intellettuale esclusiva di Lacinio S.R.L. e protetta dalle vigenti norme sul diritto d'autore (L. 633/1941 e s.m.i.). Il Cliente non è autorizzato a riprodurre, modificare, cedere a terzi o utilizzare autonomamente il materiale grafico per qualsiasi finalità — inclusa la riproduzione con altri fornitori o su altri supporti — senza preventiva e specifica autorizzazione scritta da parte di Lacinio S.R.L.</p>
                  </div>
                </div>
              </section>

              {/* 4 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">4 – Utilizzo dei servizi</h3>
                <div className="space-y-3 text-gray-700">
                  <p>IlTuoAmaro.it potrà, a propria discrezione, modificare o sospendere temporaneamente o definitivamente i propri servizi o alcune funzionalità.</p>
                  <p>L'utente si impegna a non utilizzare il sito in modo improprio e a rispettare tutte le istruzioni fornite.</p>
                  <p>Sono vietate attività di accesso non autorizzato, manipolazione dei sistemi informatici, scansione di vulnerabilità, uso di bot o metodi automatici non consentiti, diffusione di malware o spam.</p>
                </div>
              </section>

              {/* 5 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">5 – Chi può utilizzare i servizi</h3>
                <div className="text-gray-700">
                  <p className="mb-3">L'utilizzo dei servizi è vietato a:</p>
                  <ul className="list-disc list-inside space-y-1 ml-2">
                    <li>Minori di 18 anni o soggetti al di sotto dell'età legale per l'acquisto di alcolici nel Paese di residenza;</li>
                    <li>Soggetti non autorizzati dalla legge a ricevere prodotti alcolici o servizi correlati;</li>
                    <li>Utenti a cui sia stato disabilitato l'account per violazioni di legge o delle presenti condizioni.</li>
                  </ul>
                </div>
              </section>

              {/* 6 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">6 – Erogazione dei servizi</h3>
                <div className="space-y-3 text-gray-700">
                  <p>Lacinio S.R.L. non è responsabile di malfunzionamenti derivanti da cause non imputabili al proprio controllo, come problemi di rete, virus informatici, attacchi hacker o errori di sistema.</p>
                  <p>L'utente accetta di manlevare il Titolare da qualsiasi responsabilità derivante da tali eventi.</p>
                </div>
              </section>

              {/* 7 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">7 – Account utente</h3>
                <div className="space-y-3 text-gray-700">
                  <p>Per usufruire di alcuni servizi può essere necessario creare un account personale.</p>
                  <p>L'utente è responsabile della riservatezza delle proprie credenziali e di tutte le attività svolte con il proprio account.</p>
                  <p>Lacinio S.R.L. potrà sospendere o chiudere un account in caso di uso illecito o violazione delle presenti condizioni.</p>
                </div>
              </section>

              {/* 8 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">8 – Proprietà intellettuale</h3>
                <div className="space-y-4 text-gray-700">
                  <p>Tutti i diritti sui contenuti, marchi, loghi, immagini e design del sito sono riservati a Lacinio S.R.L. L'uso del sito non comporta il trasferimento di alcun diritto di proprietà intellettuale.</p>

                  <div>
                    <h4 className="font-semibold mb-2">8.1 Contenuti creati dagli utenti</h4>
                    <p>L'utente mantiene la titolarità dei contenuti caricati (es. immagini, testi o grafiche), ma concede a Lacinio S.R.L. una licenza non esclusiva, gratuita e globale per l'utilizzo tecnico necessario all'erogazione dei servizi (archiviazione, stampa, modifica e distribuzione).</p>
                  </div>

                  <div>
                    <h4 className="font-semibold mb-2">8.2 Uso del nome e dell'immagine</h4>
                    <p>L'utente autorizza l'uso del proprio nome o immagine del profilo in relazione a contenuti sponsorizzati, promozionali o dimostrativi, senza diritto a compenso.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold mb-2">8.3 Proprietà esclusiva delle ricette</h4>
                    <p>Tutte le ricette create, sviluppate o messe a disposizione da Lacinio S.R.L. — sia quelle già in catalogo sia quelle formulate su misura — sono di esclusiva proprietà intellettuale di Lacinio S.R.L. e tutelate ai sensi della normativa vigente sul diritto d'autore e sulla riservatezza industriale. Nessuna ricetta, in tutto o in parte, può essere copiata, divulgata, ceduta o riprodotta senza esplicito consenso scritto di Lacinio S.R.L. Per l'acquisto della titolarità di una ricetta si rimanda a quanto previsto all'art. 3.1.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold mb-2">8.4 Proprietà della grafica realizzata da Lacinio S.R.L.</h4>
                    <p>Tutti i progetti grafici, le etichette, i rendering e qualsiasi altro materiale visivo realizzato da Lacinio S.R.L. per conto del Cliente rimangono di proprietà esclusiva di Lacinio S.R.L. fino alla stipula di un separato accordo scritto di cessione dei diritti. Il Cliente non è autorizzato a utilizzare, riprodurre, modificare o cedere tali materiali a terzi senza preventiva autorizzazione scritta del Titolare. Si rimanda a quanto previsto agli artt. 3.2 e 15.</p>
                  </div>
                </div>
              </section>

              {/* 9 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">9 – Regole di comportamento</h3>
                <div className="text-gray-700">
                  <p className="mb-3">Sono vietati contenuti o comportamenti che includano:</p>
                  <ul className="list-disc list-inside space-y-1 ml-2">
                    <li>Violenza, odio, discriminazione o incitazione a comportamenti illegali;</li>
                    <li>Pornografia, sfruttamento minorile, molestie o diffamazione;</li>
                    <li>Violazioni di copyright, marchi o diritti di terzi;</li>
                    <li>Attività illegali, spam o manipolazione della piattaforma.</li>
                  </ul>
                  <p className="mt-3">Il Titolare segnalerà eventuali violazioni alle autorità competenti.</p>
                </div>
              </section>

              {/* 10 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">10 – Pubblicità</h3>
                <p className="text-gray-700">
                  Non è consentito pubblicare o diffondere contenuti pubblicitari di terze parti senza l'autorizzazione del Titolare.
                </p>
              </section>

              {/* 11 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">11 – Rimborsi e diritto di recesso</h3>
                <div className="space-y-3 text-gray-700">
                  <p>Poiché tutti i prodotti di IlTuoAmaro.it sono personalizzati e confezionati su misura, il diritto di recesso è escluso ai sensi dell'art. 59, lett. c) del Codice del Consumo.</p>
                  <p>È possibile richiedere l'annullamento dell'ordine entro 1 ora dal pagamento, scrivendo a <a href="mailto:info@iltuoamaro.it" className="text-purple-600 underline">info@iltuoamaro.it</a>.</p>
                </div>
              </section>

              {/* 12 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">12 – Pagamenti</h3>
                <div className="text-gray-700">
                  <p className="mb-3">Sono accettate le seguenti modalità di pagamento:</p>
                  <ul className="list-disc list-inside space-y-1 ml-2">
                    <li>Carta di Credito/Debito (Visa, Mastercard, American Express)</li>
                    <li>PayPal</li>
                    <li>Bonifico Bancario (per ordini superiori a 12 bottiglie)</li>
                  </ul>
                  <p className="mt-3">Tutte le transazioni avvengono tramite canali sicuri (SSL) e provider certificati. Lacinio S.R.L. non accede né memorizza i dati delle carte di credito.</p>
                </div>
              </section>

              {/* 13 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">13 – Tempi di produzione e spedizione</h3>
                <div className="space-y-3 text-gray-700">
                  <p>I tempi complessivi per la produzione e la consegna di tutti gli ordini sono di <strong>venti (20) giorni lavorativi</strong> dalla conferma del pagamento, indipendentemente dal quantitativo ordinato.</p>
                  <p>Tali termini sono da considerarsi indicativi e non costituiscono un obbligo contrattuale ai sensi dell'art. 1183 c.c.</p>
                  <p>Per ordini di volumi particolarmente elevati o con caratteristiche speciali, Lacinio S.R.L. potrà concordare con il Cliente tempistiche differenti, da comunicare preventivamente per iscritto. I tempi decorrono dal momento della conferma di pagamento.</p>
                </div>
              </section>

              {/* 14 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">14 – Spedizioni e consegne</h3>
                <div className="space-y-4 text-gray-700">
                  <p>Le spedizioni sono effettuate tramite corriere (generalmente GLS). I tempi di consegna del corriere sono compresi nel termine complessivo di <strong>venti (20) giorni lavorativi</strong> indicato all'art. 13. È richiesta la firma di un maggiorenne alla consegna.</p>

                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <h4 className="font-semibold text-gray-800 mb-3">Costi di Spedizione</h4>
                    <ul className="list-disc list-inside space-y-1 ml-2 text-gray-700">
                      <li>Spedizione <strong>GRATUITA</strong> da 120 bottiglie in su</li>
                      <li>24 bottiglie: <strong>15,00€ + IVA</strong></li>
                      <li>Ogni multiplo di 6 bottiglie in più: <strong>+5,00€ + IVA</strong></li>
                    </ul>
                    <p className="mt-3 text-sm text-gray-600 italic">
                      Esempio: 30 bottiglie = 20,00€ + IVA | 36 bottiglie = 25,00€ + IVA | 42 bottiglie = 30,00€ + IVA, ecc.
                    </p>
                  </div>

                  <p>Eventuali prodotti danneggiati o non conformi devono essere segnalati entro <strong>24 ore</strong> dall'arrivo della merce, allegando foto all'email <a href="mailto:info@iltuoamaro.it" className="text-purple-600 underline">info@iltuoamaro.it</a>.</p>
                </div>
              </section>

              {/* 15 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">15 – Personalizzazione delle etichette</h3>
                <div className="space-y-4 text-gray-700">
                  <p>L'utente è responsabile del contenuto grafico e testuale inserito. È vietato includere testi, simboli o immagini che violino norme di legge o diritti di terzi. Lacinio S.R.L. si riserva il diritto di rifiutare o annullare ordini che contengano contenuti offensivi, illegali o non conformi.</p>

                  <div>
                    <h4 className="font-semibold mb-2">Grafica realizzata da Lacinio S.R.L.</h4>
                    <p>La grafica progettata e realizzata da Lacinio S.R.L. per le etichette e il packaging delle bottiglie del Cliente è di proprietà esclusiva di Lacinio S.R.L. (cfr. artt. 3.2 e 8.4). Il Cliente non potrà riprodurla, modificarla o utilizzarla in modo autonomo presso altri fornitori senza espressa autorizzazione scritta.</p>
                    <p className="mt-3">Qualsiasi utilizzo non autorizzato costituisce violazione dei diritti di proprietà intellettuale e potrà comportare l'applicazione di penali contrattuali e il ricorso alle competenti sedi legali.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold mb-2">15.1 – Variazioni di stampa e non uniformità tra lotti</h4>
                    <p>Le etichette vengono prodotte mediante stampa digitale. Lacinio S.R.L. non è responsabile di eventuali variazioni cromatiche, differenze di resa grafica o non uniformità tra un lotto e l'altro, in quanto tali scostamenti sono una caratteristica intrinseca della tecnologia di stampa digitale e non costituiscono vizio o difetto del prodotto.</p>
                    <p className="mt-3">Il Cliente prende atto e accetta che la stampa digitale non garantisce una perfetta uniformità tra lotti diversi per quanto riguarda colori, tonalità, saturazione e resa complessiva dell'etichetta. Lacinio S.R.L. è pertanto esonerata da qualsiasi responsabilità per richieste di rimborso, sostituzione o risarcimento fondate su tali variazioni.</p>
                    <p className="mt-3">Si raccomanda al Cliente di verificare attentamente le prove di stampa (campionature) prima della conferma dell'ordine definitivo, in quanto l'approvazione del campione costituisce accettazione degli standard di stampa applicati.</p>
                  </div>
                </div>
              </section>

              {/* 16 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">16 – Reclami e segnalazioni</h3>
                <p className="text-gray-700">
                  Eventuali reclami, segnalazioni o richieste di supporto possono essere inviati tramite la sezione Contatti del sito o via email a{' '}
                  <a href="mailto:info@iltuoamaro.it" className="text-purple-600 underline">info@iltuoamaro.it</a>.
                </p>
              </section>

              {/* 17 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">17 – Disposizioni finali</h3>
                <p className="text-gray-700">
                  Lacinio S.R.L. si riserva il diritto di modificare, sospendere o interrompere in qualsiasi momento i propri servizi, nonché di aggiornare le presenti Condizioni d'Uso.
                </p>
              </section>

              {/* 18 */}
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">18 – Giurisdizione</h3>
                <p className="text-gray-700">
                  L'utilizzo del sito è regolato dalla legge italiana. Per qualsiasi controversia sarà competente in via esclusiva il <strong>Foro di Crotone (KR)</strong>.
                </p>
              </section>

            </div>

            {/* Footer legale */}
            <div className="mt-12 pt-6 border-t border-gray-200 text-sm text-gray-500 space-y-2">
              <p>Ultimo aggiornamento: <strong>23/07/2026</strong></p>
              <p>
                Lacinio S.R.L. – IlTuoAmaro.it<br />
                Via G. Mercalli, 16 – Z.I. | 88900 Crotone (KR) | P.IVA 03714460791 – REA KR-184420<br />
                ✉ <a href="mailto:info@iltuoamaro.it" className="text-purple-600 underline">info@iltuoamaro.it</a> | ☎ +39 0962 937186
              </p>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
